import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid2";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import React, { useContext, useState } from "react";
import TricsSystemInfoViewModel from "./ViewModels/TricsSystemInfoViewModel";
import { APIContext } from "../Contexts/APIContext";
import { AuthContext } from "../Authorisation/AuthContext";
import { SessionContext } from "../Contexts/SessionContext";
import { TelemetryContext } from "../Contexts/TelemetryContext";
import Line from "../Utilities/Line";
import { MyNotifications } from "../Notifications/MyNotifications";
import { SocialStack } from "./SocialStack";
import { useNavigate } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import {
    TERMS_AND_CONDITIONS_FILE_NAME,
    openTermsAndConditions
} from "../Authorisation/TermsAndConditions";
export default function Home() {
    const TRICS_8_KEY_CHANGES_FILE_NAME = "TRICS 8 Key Changes";
    const currentYear = new Date().getFullYear();
    const navigate = useNavigate();
    const { get, getPDF, showMessage, version } = useContext(APIContext);
    const { userDetails } = useContext(AuthContext);
    const { logFileAccess } = useContext(TelemetryContext);
    const { loadSession } = useContext(SessionContext);
    const [systemInfoViewModel, setSystemInfoViewModel] = useState<TricsSystemInfoViewModel>(new TricsSystemInfoViewModel());
    const [open, setOpen] = useState<boolean>(false);
    const [sessionCode, setSessionCode] = useState('');

    const oldFormatRegex = new RegExp('^(AUDIT(.)+$)');

    React.useEffect(() => {
        if (version !== -1)
            getData();
    }, [version]);

    const getFile = () => {
        logFileAccess(TERMS_AND_CONDITIONS_FILE_NAME, "Home");
        openTermsAndConditions();
    };

    const getData = async () => {
        get("HomePage", `GetSystemInformation`, setSystemInfoViewModel)
    }

    const handleOpenPDF = () => {
        const currentYear = new Date().getFullYear();
        logFileAccess(`TRICS Good Practice Guide ${currentYear}`, "Home");
        getPDF(
            'Document',
            `GetLibraryFile?folder=GoodPracticeGuide&fileName=TRICS Good Practice Guide ${currentYear}`,
            `TRICS Good Practice Guide ${currentYear}`,
            true
        );
    };

    const handleOpenTrics8KeyChanges = () => {
        logFileAccess(TRICS_8_KEY_CHANGES_FILE_NAME, "Home");
        getPDF(
            "Document",
            `GetLibraryFile?folder=MiscReports&fileName=${TRICS_8_KEY_CHANGES_FILE_NAME}`,
            TRICS_8_KEY_CHANGES_FILE_NAME,
            true
        );
    };

    const auditSession = async () => {
        if (oldFormatRegex.test(sessionCode))
            showMessage("error", "This code is for an old version of TRICS, please find this report in the offline TRICS archive")
        else
            loadSession(sessionCode);
    }

    const textChange = async (e) => {
        setSessionCode(e.target.value)
    }

    return (
        <>

            <Grid container alignItems="flex-start">
                <Grid size={12} >
                    <Typography variant="h4" gutterBottom>TRICS Dashboard</Typography>
                </Grid>
                <Grid size={3} container>
                    <Grid size={12} container component={Paper}>
                        <Grid size={12}>
                            <Typography variant="h6">User Details</Typography>
                        </Grid>
                        <Line />
                        <Grid size={12}>
                            <Typography variant="body1">Name: {userDetails?.userFullName}</Typography>
                        </Grid>
                        <Grid size={12}>
                            <Typography variant="body1">Email: {userDetails?.userEmail}</Typography>
                        </Grid>
                        <Grid size={12}>
                            <Typography variant="body1">Member No: {userDetails?.memberNumber}</Typography>
                        </Grid>
                        <Grid size={12}>
                            <Typography variant="body1">Organisation: {userDetails?.organisationName}</Typography>
                        </Grid>
                        <Grid size={12}>
                            <Typography variant="body1">Office: {userDetails?.siteName}</Typography>
                        </Grid>
                        <Grid size={12}>
                            <Typography variant="body1">Licence Type: {userDetails?.licence}</Typography>
                        </Grid>
                    </Grid>
                    <Grid size={12} container component={Paper}>
                        <Grid size={12}>
                            <Typography variant="h6">System Details</Typography>
                        </Grid>
                        <Line />
                        <Grid size={12}>
                            <Typography variant="body1">TRICS Version: {systemInfoViewModel.version}</Typography>
                        </Grid>
                        <Grid size={12}>
                            <Typography variant="body1">&copy; 2005-{currentYear} TRICS Consortium Limited</Typography>
                        </Grid>
                        <Grid size={12}>
                            <Typography variant="body1">Number of Members: {systemInfoViewModel.numberOfMembers}</Typography>
                        </Grid>
                        <Grid size={12}>
                            <Typography variant="body1">Number of Sites on System: {systemInfoViewModel.numberOfSites}</Typography>
                        </Grid>
                        <Grid size={12}>
                            <Typography variant="body1">Number of Days of Data: {systemInfoViewModel.daysofData}</Typography>
                        </Grid>
                    </Grid>
                    <Grid size={12} container component={Paper}>
                        <Grid size={12}>
                            <Typography variant="h6">Session Auditing</Typography>
                        </Grid>
                        <Line />
                        <Grid size={12}>
                            <TextField value={sessionCode} onChange={textChange} />
                        </Grid>
                        <Grid size={12}>
                            <Button onClick={auditSession}>Audit</Button>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid size={6} container>
                    <Grid size={12} container component={Paper}justifyContent="flex-start">
                        <Grid size={12}>
                            <Typography variant="h6">Quick Links</Typography>
                        </Grid>
                        <Line />
                        <Grid>
                            <Button onClick={() => navigate("/triprate")} startIcon={<QueryStatsIcon/> }>Trip Rate</Button>
                        </Grid>
                        <Grid>
                            <Button onClick={() => navigate("/sitelist")} startIcon={<FormatListBulletedIcon />}>Site List</Button>
                        </Grid>
                        <Grid>
                            <Button onClick={() => navigate("/timeseriesanalysis")} startIcon={<AnalyticsIcon />}>Time Series Analysis</Button>
                        </Grid>
                    </Grid>
                    <Grid size={12} container component={Paper}>
                        <Grid size={12}>
                            <Typography variant="h6">Notifications</Typography>
                        </Grid>
                        <Line />
                        <Grid size={12}>
                            <MyNotifications />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid size={3} container>
                    <Grid size={12} container component={Paper}>
                        <Grid size={12}>
                            <Typography variant="h6">Useful Links</Typography>
                        </Grid>
                        <Line />
                        <Grid size={12}>
                            <Button onClick={handleOpenPDF} variant="outlined">TRICS Good Practice Guide</Button>
                        </Grid>
                        <Grid size={12}>
                            <Button onClick={handleOpenTrics8KeyChanges} variant="outlined">TRICS 8 Key Changes</Button>
                        </Grid>
                        <Grid size={12}>
                            <Button onClick={getFile} variant="outlined">TRICS Licence Terms & Conditions</Button>
                        </Grid>
                        <Grid size={12}>
                            <Button onClick={() => setOpen(true)} variant="outlined">TRICS Intellectual Property Rights</Button>
                        </Grid>
                        <Grid size={12}>
                            <Button onClick={() => navigate("/softwarearchive")} variant="outlined">Offline Software Archive</Button>
                        </Grid>
                        <Grid size={12}>
                            <Button onClick={() => navigate("/additionallinks")} variant="outlined">Additional Links</Button>
                        </Grid>
                    </Grid>
                    <Grid size={12} container component={Paper}>
                        <Grid size={12}>
                            <Typography variant="h6">Follow Us</Typography>
                        </Grid>
                        <Line />
                        <Grid size={12}>
                            <Typography variant="body1">Email our support team here: <a href="mailto:support@trics.org">support@trics.org</a></Typography>
                        </Grid>
                        <Grid size={12}>
                            <Typography variant="body1">Call us on: 020 3657 2186</Typography>
                        </Grid>
                        <Grid size={12}>
                            <Typography variant="body1">Or visit our website <a href="https://trics.co.uk/" target="_blank">trics.org</a></Typography>
                        </Grid>
                        <Grid size={12}>
                            <SocialStack />
                        </Grid>
                    </Grid>
                </Grid>
                <Dialog
                    open={open}
                    onClose={() => setOpen(false)}
                >
                    <DialogTitle>Intellectual Property Rights</DialogTitle>
                    <DialogContent>
                        <Typography>
                            The survey data, graphs and all associated supporting information, contained within the TRICS Database are created and published by TRICS Consortium Limited ("the Company") and the Company claims copyright and database rights in this published work. Use of this data is restricted to current TRICS licence holders and those using the TRICS Bureau Service. Licence holders may publish data from the TRICS Database in accordance with the TRICS licence. TRICS data, or extracts of TRICS data, should only be provided to third parties as part of a complete planning application document or in accordance with the Company's Bureau Services or the members' terms of licence. Data should not be attained by copying extracts from previously published reports or other documents. Any use, publication or distribution of data owned by the Company, whether obtained from the TRICS Database or from third party operated planning portals, without the Company's authorisation or a valid TRICS licence (other than in accordance with the Company's Bureau Service), will infringe the Company's intellectual property rights in the data. Please be aware that any unauthorised use of data contained in online planning portals may constitute a breach of the third party's terms of use and/or an infringement of its intellectual property rights.
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setOpen(false)}>Close</Button>
                    </DialogActions>
                </Dialog>
            </Grid>
        </>
    );
}
